export const GET_MEDICAL_BILL_SUCCESS = "GET_MEDICAL_BILL_SUCCESS";
export const GET_MEDICAL_BILL_FAIL = "GET_MEDICAL_BILL_FAIL";

export const GET_BOOKING_INFO_CSKH = "GET_PAYMENT_INFO_CSKH";
export const GET_BOOKING_INFO_CSKH_SUCCESS = "GET_PAYMENT_INFO_CSKH_SUCCESS";
export const GET_BOOKING_INFO_CSKH_FAIL = "GET_PAYMENT_INFO_CSKH_FAIL";
export const RESET_BOOKING_INFO_CSKH = "RESET_BOOKING_INFO_CSKH";

// this action is not currently use
export const CHANGE_HOSPITAL_CSKH = "CHANGE_HOSPITAL_CSKH";

export const GET_PATIENTS_BY_PHONE_CSKH = "GET_PATIENTS_BY_PHONE_CSKH";
export const GET_PATIENTS_BY_PHONE_CSKH_SUCCESS =
  "GET_PATIENTS_BY_PHONE_CSKH_SUCCESS";
export const GET_PATIENTS_BY_PHONE_CSKH_FAIL =
  "GET_PATIENTS_BY_PHONE_CSKH_FAIL";

export const SELECT_PATIENT_CSKH = "SELECT_PATIENT_CSKH";
export const CLEAR_SELECTED_PATIENT = "CLEAR_SELECTED_PATIENT";

export const SET_CSKH_SECRET_KEY = "SET_CSKH_SECRET_KEY";

export const DELETE_PATIENT_BY_CSKH = "DELETE_PATIENT_BY_CSKH";
export const DELETE_PATIENT_BY_CSKH_SUCCESS = "DELETE_PATIENT_BY_CSKH_SUCCESS";
export const DELETE_PATIENT_BY_CSKH_FAIL = "DELETE_PATIENT_BY_CSKH_FAIL";

export const SEND_BOOKING_VIA_EMAIL = "SEND_BOOKING_VIA_EMAIL";
export const SEND_BOOKING_VIA_SMS = "SEND_BOOKING_VIA_SMS";

export const UPDATE_CANCEL_BILL = "UPDATE_CANCEL_BILL";

export const GET_TRANSACTIONID_INFO_CSKH = "GET_TRANSACTIONID_INFO_CSKH";

export const GET_TRANSACTIONID_INFO_CSKH_SUCCESS =
  "GET_TRANSACTIONID_INFO_CSKH_SUCCESS";

export const GET_TRANSACTIONID_INFO_CSKH_FAIL =
  "GET_TRANSACTIONID_INFO_CSKH_FAIL";

export const RESET_TRANSACTIONID_INFO_CSKH = "RESET_TRANSACTIONID_INFO_CSKH";

export const REQUEST_CHECK_VOUCHER_CARE247 = "REQUEST_CHECK_VOUCHER_CARE247";

export const REQUEST_CHECK_VOUCHER_CARE247_SUCCESS =
  "REQUEST_CHECK_VOUCHER_CARE247_SUCCESS";

export const REQUEST_CHECK_VOUCHER_CARE247_FAIL =
  "REQUEST_CHECK_VOUCHER_CARE247_FAIL";

export const REQUEST_CHECK_VOUCHER_CARE247_RESET =
  "REQUEST_CHECK_VOUCHER_CARE247_RESET";

export const REQUEST_CARE247_INDEPENDENT_CSKH =
  "REQUEST_CARE247_INDEPENDENT_CSKH";

export const GET_REQUEST_CARE247_INDEPENDENT_CSKH_SUCCESS =
  "GET_REQUEST_CARE247_INDEPENDENT_CSKH_SUCCESS";

export const GET_REQUEST_CARE247_INDEPENDENT_CSKH_FAIL =
  "GET_HREQUEST_CARE247_INDEPENDENT_CSKH_FAIL";

export const REQUEST_CARE247_INDEPENDENT_CSKH_RESET =
  "REQUEST_CARE247_INDEPENDENT_CSKH_RESET";

export const REQUEST_CARE247_SERVICES = "REQUEST_CARE247_SERVICES";

export const GET_REQUEST_CARE247_SERVICES_SUCCESS =
  "GET_REQUEST_CARE247_SERVICES_SUCCESS";

export const GET_REQUEST_CARE247_SERVICES_FAIL =
  "GET_REQUEST_CARE247_SERVICES_FAIL";

export const GET_REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH_SUCCESS =
  "GET_REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH_SUCCESS";

export const GET_REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH_FAIL =
  "GET_REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH_FAIL";

export const REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH =
  "REQUEST_CONFIRM_ASSISTED_PAYMENT_CSKH";

export const REQUEST_BOOKINGS_BY_PATIENT_CSKH =
  "REQUEST_BOOKINGS_BY_PATIENT_CSKH";
// Get History Booking
export const GET_HISTORY_BOOKING_CSKH = "GET_HISTORY_BOOKING_CSKH";
export const REQUEST_BOOKINGS_BY_PATIENT_CSKH_SUCCESS =
  "REQUEST_BOOKINGS_BY_PATIENT_CSKH_SUCCESS";
// Get Copy to clipboard
export const GET_COPY_TO_CLIPBOARD = "GET_COPY_TO_CLIPBOARD";
export const GET_COPY_TO_CLIPBOARD_SUCCESS = "GET_COPY_TO_CLIPBOARD_SUCCESS";
export const GET_COPY_TO_CLIPBOARD_FAIL = "GET_COPY_TO_CLIPBOARD_FAIL";

export const INSERT_PATIEN_INTO_USER_CSKH = "INSERT_PATIEN_INTO_USER_CSKH";

export const SET_CS_TOKEN = "SET_CS_TOKEN";

export const SELECT_PATIENT_CSKH_BY_ID = "SELECT_PATIENT_CSKH_BY_ID";

export const RESET_ALL_CS = "RESET_ALL_CS";
export const RESET_BOOKING_BY_PATIENT_CS = "RESET_BOOKING_BY_PATIENT_CS";

export const GET_HISTORY_BOOKING = "GET_HISTORY_BOOKING";
export const GET_HISTORY_BOOKING_SUCCESS = "GET_HISTORY_BOOKING_SUCCESS";
export const GET_HISTORY_BOOKING_FAIL = "GET_HISTORY_BOOKING_FAIL";
